import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-msg-dialog',
  templateUrl: './msg-dialog.component.html',
  styleUrls: ['./msg-dialog.component.css']
})
export class MsgDialogComponent implements OnInit {

  constructor(private apiService: ApiService, private  activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }


  submit(){
    this.activeModal.close();
  }



}
